import getTimeZoneMessageValue from 'src/internal/display-name-formatter/getTimeZoneMessageValue';
import handleGlobalizeError from 'src/internal/errors/handleGlobalizeError/handleGlobalizeError';
import {timezoneMessages} from 'src/public/timezoneMessages/timezoneMessages';

import type {IReports} from '@sail/observability';
import type {LocaleData} from 'src/types';

export default function getTimeZoneDisplayNameValue(
  localeData: LocaleData,
  value: string,
  reports: IReports,
): string {
  const descriptor = timezoneMessages[value];
  if (!descriptor) {
    handleGlobalizeError(new Error(`E_UNKNOWN_TIMEZONE: "${value}"`), reports);
  }

  return getTimeZoneMessageValue(localeData, descriptor);
}
